import {load} from '@shopify/theme-sections'
import '../sections/template-article'
import '../../styles/templates/article.scss'

load([`template-article`])
